// extracted by mini-css-extract-plugin
export default {"rdblock":"eR","container":"fR","rddesc":"gR","title":"hR","copy":"iR","image":"jR","tipview":"kR","rdtip":"lR"};
    if(module.hot) {
      // 1715276859163
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  